import { render, staticRenderFns } from "./HelpCenterMenu.vue?vue&type=template&id=052ffefa&scoped=true&"
import script from "./HelpCenterMenu.vue?vue&type=script&lang=js&"
export * from "./HelpCenterMenu.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterMenu.vue?vue&type=style&index=0&id=052ffefa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ffefa",
  null
  
)

export default component.exports